export default "__VITE_ASSET__B2M78EZl__"